module.exports = "<div>\n    <input #switch data-switch=\"true\" type=\"checkbox\" [attr.data-on-text]=\"texts.on\" data-handle-width=\"70\" [attr.data-off-text]=\"texts.off\" [attr.data-on-color]=\"colorOn\" >\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/boolean-switch/boolean-switch.component.html
// module id = ../../../../../src/app/shared/boolean-switch/boolean-switch.component.html
// module chunks = main